import PlisseCalcPlisse from '../components/calc/plisse/CalcPlisse.svelte';
import PlisseCalcSlimPro from '../components/calc/plisse/CalcSlimPro.svelte';
import PlisseCalcSmart from '../components/calc/moskitos/CalcSmart.svelte';
import PlisseCalcPlugin from '../components/calc/moskitos/CalcVstavnaya.svelte';
import PlisseCalcCommon from '../components/calc/moskitos/CalcCommon.svelte';
import PlisseCalcSlim from '../components/calc/moskitos/CalcSlim.svelte';
import PartMaterials from '../components/parts/Materials.svelte';
import CalcMounting from '../components/calc/CalcMounting.svelte';
import CalcPacking from '../components/calc/CalcPacking.svelte';
import PartPrice from '../components/parts/Price.svelte';
import PlisseCalcShtory from '../components/calc/moskitos/CalcPlisseShtoryMoskitos.svelte';
import PlisseCalcAlumPro from '../components/calc/plisse/CalcAlumPro.svelte';
import ShtoraCalcMax from "../components/calc/moskitos/CalcShtoraMax.svelte";

let list = [];
let logo = null;
let precision = null;
let chutzpah = false;

if (APP_TYPE === 'moskitoscompany') {
    logo = 'moskitoscompany.jpg';
    precision = 1;
    chutzpah = true;

    list.push({
        title: 'Москитная система Pro 40',
        calc: 'Smart',
        img: '/img/plisse/setkipro/setki.pro_smart.png',
        description: 'Профиль: 40x25 мм. Длина волны сетки: 14-16 мм. Для проёмов размеров ШхВ 1600х2500 мм',
        link: 'pro40',
        component: PlisseCalcSmart,
        components: [
            PartPrice,
            CalcMounting,
            CalcPacking,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
                'Декорал': 'Декорал',
            },
            max: {
                width: 6000,
                height: 3000
            },
            webtype: [
                'Обычная',
                'Антикошка',
                'Антипыль',
            ]

        }
    });

    list.push({
        title: 'Москитная система Classic 20',
        calc: 'Slim',
        img: '/img/plisse/setkipro/setki.pro_slim.png',
        description: 'Профиль: 25x18 мм. Длина волны сетки: 12-14 мм. Для проёмов размеров ШхВ 1000х2000 мм',
        link: 'Classic20',
        component: PlisseCalcSlim,
        components: [
            PartPrice,
            CalcMounting,
            CalcPacking,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
                'Декорал': 'Декорал',
            },
            max: {
                width: 2100,
                height: 2200
            },
            recomend: {
                width: 1200,
                height: 2500
            },
            webtype: [
                'Обычная',
                'Антикошка',
                'Антипыль',
            ]
        }
    });

    list.push({
        title: 'Вставная москитная сетка',
        calc: 'Вставная',
        img: '/img/plisse/setkipro/setki.pro_vstavnaya.png',
        description: 'Профиль: 30x25 мм. Для окон размеров 1000х2100 мм',
        link: 'вставная',
        component: PlisseCalcPlugin,
        components: [
            PartPrice,
            CalcPacking,
            PartMaterials,
        ],
        options: {
            color: {
                'Антрацит': 'Антрацит(RAL7016)',
                'Анодированный(коньяк)': 'Анодированный(коньяк)',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
                'Декорал': 'Декорал',
            },
            max: {
                width: 1300,
                height: 2200
            }
        }
    });

    list.push({
        title: 'Рамочная москитная сетка',
        calc: 'Обычная',
        img: '/img/plisse/setkipro/setki.pro_econom.png',
        description: 'Профиль: 25x19 мм. Для окон размеров 900х1800 мм',
        link: 'обычная',
        component: PlisseCalcCommon,
        components: [
            PartPrice,
            CalcPacking,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
                'Декорал': 'Декорал',
            },
            max: {
                width: 1000,
                height: 2100
            }
        }
    });

    list.push({
        title: 'Шторы плиссе',
        calc: 'Шторы плиссе',
        img: '/img/plisse/PlisseShtory.jpeg',
        description: 'Плиссированные ткани, между двумя профилями.',
        link: 'шторы-плиссе',
        component: PlisseCalcShtory,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 2400,
                height: 4000
            },
            recomend: {
                width: 1200,
                height: 2700

            },
            vStrukture: 36,


            shtorytypes: {
                'Полупрозрачная' : 'Полупрозрачная',
                'Dark out' : 'Dark out  90% затемнения',
                'СОТЫ ПРЕМИУМ' :  'СОТЫ black out ПРЕМИУМ',
                'СОТЫ КЛАССИК' : 'СОТЫ black out КЛАССИК',
                'BLACKOUT однослойный' : 'BLACKOUT однослойный',
            },

            shtorySotaPoluprozcolor: [
                'белые kfd07',
                'серые kfd09',
                'бежевый kfd10',
                'коричневый kfd12',
            ],

            shtorySotacolor: [
                'белые kff01',
                'кремовый kff02',
                'коричневый kff06',
                'серый kff07',
                'голубой',
                'черный',
                'светло-серый',
                'темно-серый ',
            ],
            shtoryBlackoutcolor: [
                'антрацит',
                'бежевый',
                'серый',
                'белый',
            ],

            komplektcolor: [
                'белый',
                'серый',
                'коричневый',
                'черный',
            ],

             shtoryPoluprozcolor: [
                'Зеленый',
                'Желтый',
                'Оранжевый',
                'голубой',
                'Розовый',
                'Красный',
                 'белая',
                 'серая',
                 'кремовая',
                 'бежевая',
                 'темно-синий',
                 'коричневая',
                 'антрацит',
                 'мокко',
                 'Светло-серый 216',
                 'Темный серый 218',
                 'Черный 219',
                 'Кофе 213',
            ],



            shtoryBlackoutodnosloy: [
                'Белый',
                'Серый',
                'Бежевый',
                'Антрацит',
            ],


            nitcolor:   [
            'белая',
            'серая',
            'кремовая',
            'бежевая',
            'темно-синий',
            'коричневая',
            'мокко',
            'антрацит',
                'Желтый',
                'Зеленый',
                'Красный',
                'Оранжевый',
                'Розовый',
        ],


            color:  {
                'Белый RAL 9016': 'Белый RAL 9016',
                'Серый RAL 7040': 'Серый RAL 7040',
                'Коричневый RAL 8017': 'Коричневый RAL 8017',
                'Серый Антрацит RAL 7016': 'Серый Антрацит RAL 7016',
                'Цветной': 'Цветной',
                'Муар': 'Муар',
            }


        }
    });

    list.push({
        title: 'Москитная сетка АлюмПро',
        calc: 'АлюмПро',
        img: '/img/plisse/setkipro/setki.pro_econom.png',
        description: 'Профиль 25х17мм. Для алюминиевых окон без сверления 1000х2000мм',
        link: 'алюмпро',
        component: PlisseCalcAlumPro,
        components: [
            PartPrice,
            CalcPacking,
            PartMaterials,
        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит(RAL7016)',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
                'Декорал': 'Декорал',
            },
            max: {
                width: 1000,
                height: 2000
            }
        }
    });

    list.push({
        title: 'Штора Max',
        calc: 'Штора Max',
        img: '/img/plisse/setkipro/setki.pro_econom.png',
        description: 'Штора Max',
        link: 'штораmax',
        component: ShtoraCalcMax,
        components: [
            PartPrice,
            PartMaterials,
        ],
        options: {
            max: {
                width: 2400,
                height: 4000
            },
            recomend: {
                width: 1200,
                height: 2700

            },
            vStrukture: 44,


            shtorytypes: {
                'Полупрозрачная' : 'Полупрозрачная',
                'Dark out' : 'Dark out  90% затемнения',
                'СОТЫ ПРЕМИУМ' :  'СОТЫ black out ПРЕМИУМ',
                'СОТЫ КЛАССИК' : 'СОТЫ black out КЛАССИК',
                'СОТЫ полупрозрачные КЛАССИК' : 'СОТЫ полупрозрачные КЛАССИК',
            },

            shtorySotaPoluprozcolor: [
                'белые kfd07',
                'серые kfd09',
                'бежевый kfd10',
                'коричневый kfd12',
            ],

            shtorySotacolor: [
                'белые kff01',
                'кремовый kff02',
                'коричневый kff06',
                'серый kff07',
                'голубой',
                'черный',
                'светло-серый',
                'темно-серый ',
            ],
            shtoryBlackoutcolor: [
                'антрацит',
                'бежевый',
                'серый',
                'белый',
            ],

            komplektcolor: [
                'белый',
                'серый',
                'коричневый',
                'черный',
            ],

            shtoryPoluprozcolor: [
                'Зеленый',
                'Желтый',
                'Оранжевый',
                'голубой',
                'Розовый',
                'Красный',
                'Белый',
                'серый',
                'кремовый',
                'Бежевый',
                'темно-синий',
                'коричневый',
                'антрацит',
                'мокко',
                'Светло-серый 216',
                'Темный серый 218',
                'Черный 219',
                'Кофе 213',
            ],

            shtoryBlackoutodnosloy: [
                'Белый',
                'Серый',
                'Бежевый',
                'Антрацит',
            ],


            nitcolor:   [
                'белый',
                'серый',
                'кремовый',
                'бежевый',
                'темно-синий',
                'коричневый',
                'мокко',
                'антрацит',
                'Желтый',
                'Зеленый',
                'Красный',
                'Оранжевый',
                'Розовый',
            ],


            color:  {
                'Белый RAL 9016': 'Белый RAL 9016',
                'Коричневый RAL 8017': 'Коричневый RAL 8017',
                'Серый Антрацит RAL 7016': 'Серый Антрацит RAL 7016',
                'Муар': 'Муар',
                'Цветной': 'Цветной',
            }



        }
    });




}

export {list, logo, precision, chutzpah};
